import type { FC } from 'react';
import { Card, CardGroup, Flex, List } from '@george-labs.com/design-system';

import { AddressItemSkeleton } from './AddressItemSkeleton';

const DEFAULT_NUMBER_OF_ROWS = 2;

interface Props {
    className?: string;
    numberOfRows?: number;
    'data-cy'?: string;
}

export const AddressSkeleton: FC<Props> = ({
    className,
    numberOfRows = DEFAULT_NUMBER_OF_ROWS,
    'data-cy': dataCy,
}) => (
    <CardGroup className={className} data-cy={dataCy}>
        <Card>
            <List variant={List.VARIANT.PLAIN}>
                <div className="mb-4">
                    <AddressItemSkeleton />
                </div>
                <Flex direction="column" gap="sm">
                    {[...Array(numberOfRows).keys()].map((row) => (
                        <AddressItemSkeleton key={`address-skeleton-item-${row}`} />
                    ))}
                </Flex>
            </List>
        </Card>
    </CardGroup>
);
